import React from 'react'
import { Empty, Popconfirm, Table, Tooltip, message } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'

import { deleteUnavailableDay } from '../services'
import { handleError } from '../../../helpers'

export default function UnavailableDaysTable({ unavailableDays, reload }) {
	const columns = [
		{
			title: 'Fecha',
			dataIndex: 'date'
		},
		{
			title: 'Motivo',
			dataIndex: 'reason'
		},
		{
			title: 'Registrado por',
			dataIndex: 'user',
			render: t => t.name
		},
		{
			title: 'Acciones',
			width: '100px',
			render: (t, r) => (
				<React.Fragment>
					<Popconfirm
						title="Esta acción no se puede revertir"
						okText="Eliminar"
						cancelText="Cancelar"
						okButtonProps={{ danger:true }}
						onConfirm={() => handleDelete(r.id)}
					>
						<Tooltip 
							title="Eliminar" 
							className='text-link'
							placement='bottom'
						>
							<FontAwesomeIcon icon={faTrash} />
						</Tooltip>
					</Popconfirm>
				</React.Fragment>
			)
		}
	]

	const handleDelete = id => {
		deleteUnavailableDay(id)
			.then(res => {
				message.success(res.data.message)
				reload()
			})
			.catch(error => handleError(error))
	}

	return (
		<React.Fragment>
			<Table 
				dataSource={unavailableDays}
				columns={columns}
				rowKey={r => r.id}
				loading={!unavailableDays}
				size='small'
				locale={{ 
					emptyText: (
						<Empty 
							description="No se encontraron registros" 
							imageStyle={{ height:'80px' }}
						/>
					) 
				}}
			/>
		</React.Fragment>
	)
}